import styled from 'react-emotion';

const Triangle = styled.div`
  position: relative;
  background-color: orange;
  text-align: left;
  font-size: 1rem;
  &:before,
  &:after {
    content: '';
    position: absolute;
    background-color: inherit;
  }
  width: 10em;
  height: 10em;
  &:before,
  &:after {
    width: 10em;
    height: 10em;
    border-top-right-radius: 30%;
  }

  transform: rotate(-60deg) skewX(-30deg) scale(1, 0.866);

  &:before {
    transform: rotate(-135deg) skewX(-45deg) scale(1.414, 0.707) translate(0, -50%);
  }
  &:after {
    transform: rotate(135deg) skewY(-45deg) scale(0.707, 1.414) translate(50%);
  }
`;

export default Triangle;



// WEBPACK FOOTER //
// ./src/icons/css/Triangle.jsx